import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "email-count",
  "use": "email-count-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"email-count\">\n    <circle cx=\"11\" cy=\"11\" r=\"10.5\" fill=\"white\" stroke=\"#222530\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol